import React from "react";
import { toJS } from "mobx";
import {
  WeaTablePage,
  WeaLocaleProvider,
  WeaInputEncrypt,
  WeaTools
} from "ecCom";
const formatMultiLang = WeaLocaleProvider.formatMultiLang;
const { desensitization, encryption, replaceEncryption } = WeaTools.EncryBase;

import { observer } from "mobx-react";
import isFunction from "lodash/isFunction";
import remove from "lodash/remove";
import middleware from "../../../middleware";

@observer
class WeaTableMobx extends React.PureComponent {
  constructor(props) {
    super(props);
    this.lastTableData = "";
    this.lastRequireTimes = 0;
    this.resetRenderTimer = null;
  }

  componentDidMount() {
    const { comsWeaTableStore } = this.props;
    /**
     * 给 store 传递当前 Table 实例，用于回调强制更新，为了避免 json 循环引用，需要删除 component 属性
     *
     */
    if (!comsWeaTableStore.component) {
      delete this.props.comsWeaTableStore.component;
      if (typeof comsWeaTableStore.forceUpdate === "function") {
        comsWeaTableStore.forceUpdate(this);
      }
    }
    if (this.props.uniqueId) {
      comsWeaTableStore.tableUpdate({
        uniqueId: this.props.uniqueId,
        rowKey: this.props.rowKey
      });
    }
    if (this.props.rowKey && typeof this.props.rowKey === "function") {
      comsWeaTableStore.tableUpdate({
        rowKey: this.props.rowKey
      });
    }
    if (
      this.props.expiredRefreshFun &&
      typeof this.props.expiredRefreshFun === "function"
    ) {
      comsWeaTableStore.injectExpiredRefreshFun(this.props.expiredRefreshFun);
    }
  }

  componentWillReact() {
    /**
     * 通过 hooks 给 store 存储一个当前实例是否需要更新的状态。
     */
    const { comsWeaTableStore } = this.props;
    // console.log('will React', newFirstTableRowStr, lastFirstTableRowStr);
    // this.lastTableData = toJS(this.props.comsWeaTableStore.datas);
    // this.lastTableData = toJS(this.props.comsWeaTableStore.requireTimes);
    if (this.lastTableData && toJS(comsWeaTableStore.datas).length > 0) {
      const newFirstTableRowStr = JSON.stringify(
        toJS(comsWeaTableStore.datas[0])
      );
      const lastFirstTableRowStr = JSON.stringify(this.lastTableData);
      // console.log('will React row', newFirstTableRowStr, lastFirstTableRowStr);
      const newRequireTimeStr = JSON.stringify(
        toJS(comsWeaTableStore.requireTimes)
      );
      const lastRequireTimeStr = JSON.stringify(this.lastRequireTimes);
      // console.log('will React times', newRequireTimeStr, lastRequireTimeStr);
      // if (
      //   newRequireTimeStr === lastRequireTimeStr &&
      //   newFirstTableRowStr === lastFirstTableRowStr
      // ) {
      //   comsWeaTableStore.changeShouldRender(false);
      //   if (!this.resetRenderTimer) {
      //     this.resetRenderTimer = setTimeout(() => {
      //       comsWeaTableStore.changeShouldRender(true);
      //       this.resetRenderTimer = null;
      //     }, 200);
      //   }
      // } else {
      //   comsWeaTableStore.changeShouldRender(true);
      // }
    }
    this.lastRequireTimes = toJS(comsWeaTableStore.requireTimes);
    if (toJS(comsWeaTableStore.datas).length > 0) {
      this.lastTableData = toJS(comsWeaTableStore.datas[0]);
    }
  }

  // shouldComponentUpdate() {
  //   console.log("will SCU", this.props.comsWeaTableStore.shouldRender);
  //   return this.props.comsWeaTableStore.shouldRender;
  //   // return true;
  // }

  componentWillReceiveProps(nextProps) {
    const { comsWeaTableStore } = nextProps;
    if (nextProps.uniqueId != comsWeaTableStore.uniqueId) {
      comsWeaTableStore.tableUpdate({
        uniqueId: nextProps.uniqueId,
        rowKey: nextProps.rowKey
      });
    }
  }

  getRowSel() {
    const { comsWeaTableStore, rowSelection } = this.props;
    const {
      selectedRowKeys,
      selectedUniqueIds,
      uniqueId,
      rootMap
    } = comsWeaTableStore;
    let rowSel = {
      ...rowSelection,
      type: (rootMap && rootMap.tabletype) || "checkbox",
      selectedRowKeys: uniqueId
        ? toJS(selectedUniqueIds)
        : toJS(selectedRowKeys),
      onChange(sRowKeys, selectedRows) {
        comsWeaTableStore.setSelectedRowKeys(sRowKeys);
        rowSelection &&
          isFunction(rowSelection.onChange) &&
          rowSelection.onChange(
            comsWeaTableStore.selectedRowKeys,
            selectedRows
          );
      }
    };

    return rowSel;
  }

  getColumns(params) {
    const { comsWeaTableStore, getColumns } = this.props;
    const { columns } = comsWeaTableStore;
    let newColumns = toJS(columns);
    newColumns = newColumns.map(column => {
      let newColumn = { ...column };
      //let align=column.align==undefined?"left":column.align;
      let dataalign = column.dataalign == undefined ? "" : column.dataalign;
      //style={{display:"block",textAlign:align}}
      //newColumn.title=<span>{newColumn.title}</span>;
      //AndyZhang对齐功能
      // 处理autoZoom
      if (newColumn.autoZoom) {
        newColumn.className =
          (newColumn.className || "") + " wea-table-auto-zoom-col";
      }
      newColumn.render = (text, record, index) => {
        // 前端元素转义
        const valueSpan =
          record[`${newColumn.dataIndex}span`] !== undefined
            ? record[`${newColumn.dataIndex}span`]
            : record[newColumn.dataIndex];
        let value = formatMultiLang(valueSpan);
        if (desensitization(value)) {
          return (
            <WeaInputEncrypt
              ecId={`${this.props.ecId}_WeaInputEncrypt@qcm0td@${newColumn.dataIndex}_${index}`}
              type="TEXTAREA"
              className="wea-url"
              style={{ textAlign: dataalign }}
              value={value}
              key={Math.random()
                .toString(36)
                .substr(2, 6)}
            />
          );
        } else if (encryption(value)) {
          value = replaceEncryption(value);
        }
        const span = document.createElement("span");
        span.innerHTML = value;
        return (
          <span
            title={span.innerText}
            className="wea-url"
            style={{ textAlign: dataalign }}
            dangerouslySetInnerHTML={{ __html: value }}
          />
        );
      };
      // handle resize
      if (params && params.size) {
        newColumn.width = "100px";
      }
      return newColumn;
    });
    if (typeof getColumns === "function") {
      newColumns = getColumns(newColumns) || newColumns; //避免测试时不写返回值直接报错
    }
    return newColumns;
  }

  onRowClick = (record, index, event) => {
    const {
      comsWeaTableStore,
      onRowClick,
      needRowCheck,
      needRowClick
    } = this.props;
    const {
      uniqueId,
      selectedRowKeys,
      rowKey,
      setSelectedRowKeys,
      setRowCheckKey
    } = comsWeaTableStore;
    const _selectedRowKeys = toJS(selectedRowKeys);
    const id = rowKey ? rowKey(record, index) : record.randomFieldId;
    _selectedRowKeys.indexOf(id) <= -1
      ? _selectedRowKeys.push(id)
      : remove(_selectedRowKeys, n => n === id);
    //是否开启行选中
    if (needRowCheck) {
      setSelectedRowKeys(_selectedRowKeys);
    }
    if (needRowClick) {
      setRowCheckKey([id]);
    }
    isFunction(onRowClick) && onRowClick(record, index, event);
  };

  onChange = (p, f, s) => {
    const { comsWeaTableStore } = this.props;
    comsWeaTableStore.getDatas("", p.current, p.pageSize, s, () => {}, false);
  };

  showColumnsSet = bool => {
    const { comsWeaTableStore } = this.props;
    comsWeaTableStore.setColSetVisible(bool);
  };
  onTransferChange = keys => {
    const { comsWeaTableStore } = this.props;
    comsWeaTableStore.setTableColSetkeys(keys);
  };
  saveColumnsSet = () => {
    const { comsWeaTableStore, setColCB } = this.props;
    comsWeaTableStore.tableColSet(undefined, setColCB);
  };
  saveColumnsReset = () => {
    const { comsWeaTableStore, setColCB } = this.props;
    comsWeaTableStore.tableColSet(undefined, setColCB, true);
  };

  render() {
    const {
      comsWeaTableStore,
      hasOrder,
      needScroll,
      needRowClick,
      onOperatesClick = "",
      getRender,
      customOperates
    } = this.props;
    const {
      // table
      dataKey,
      datas,
      browser,
      operates,
      sortParams,
      loading,
      showCheck,
      pageAutoWrap,
      rowstylefield,
      // 自定义列
      colSetVisible,
      colSetdatas,
      colSetKeys,
      // pagination
      count,
      current,
      pageSize,
      rootMap,
      isSts,
      stsAllData,
      stsData,
      stsDatas,
      rowCheckKey
    } = comsWeaTableStore;
    if (getRender && typeof getRender === "function") {
      return getRender(comsWeaTableStore, this.props);
    }

    return (
      <WeaTablePage
        useFixedHeader={true}
        {...this.props}
        needRowClick={needRowClick}
        rowCheckKey={toJS(rowCheckKey)}
        dataKey={dataKey}
        browser={browser}
        hasOrder={hasOrder}
        needScroll={needScroll}
        loading={loading}
        tableCheck={showCheck}
        pageAutoWrap={pageAutoWrap}
        rowstylefield={rowstylefield}
        isSts={isSts}
        stsAllData={stsAllData}
        stsData={stsData}
        stsDatas={stsDatas}
        count={count}
        current={current}
        pageSize={pageSize}
        rootMap={rootMap}
        datas={toJS(datas)}
        columns={this.getColumns()}
        rowSel={this.getRowSel()}
        operates={toJS(operates)}
        customOperates={customOperates}
        sortParams={toJS(sortParams)}
        onChange={this.onChange}
        colSetVisible={colSetVisible}
        colSetdatas={toJS(colSetdatas)}
        colSetKeys={toJS(colSetKeys)}
        showColumnsSet={this.showColumnsSet}
        onTransferChange={this.onTransferChange}
        saveColumnsSet={this.saveColumnsSet}
        saveColumnsReset={this.saveColumnsReset}
        onOperatesClick={onOperatesClick}
        onRowClick={this.onRowClick}
      />
    );
  }
}

const Com = middleware(WeaTableMobx, "WeaTableNew");
export default Com;



// WEBPACK FOOTER //
// ./comMobx/wea-table-new/components/Table.js